import { useState, FC, useCallback } from 'react';

import { Popover } from 'antd';

import STATIC_ROUTES from '@data/staticRoutes.json';
import { ResponsiveWrapper } from '@utils/styledForDisplay';

import {
  Menu,
  MenuItem,
  PopoverContentWrapper,
  LogoutButtonWrapper,
  UserOutlined,
  UserFullNameLabel,
} from './styled';
import UserMenuLink from './UserMenuLink';
import TotalMileAmount, { ITotalMileAmount } from './TotalMileAmount';

export interface IMobileLogoutButton extends ITotalMileAmount {
  fullName: string;
  isOnlyShowSignOut?: boolean;
}

const MobileLogoutButton: FC<IMobileLogoutButton> = ({
  fullName,
  totalMileAmount,
  isOnlyShowSignOut = false,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handlePopoverChange = useCallback(
    (newOpen: boolean) => setIsOpen(newOpen),
    []
  );

  const handlePopoverClose = useCallback(() => setIsOpen(false), []);

  return (
    <LogoutButtonWrapper>
      <Popover
        content={
          <PopoverContentWrapper>
            <ResponsiveWrapper displayFor='mobile'>
              <UserFullNameLabel>{fullName}</UserFullNameLabel>
            </ResponsiveWrapper>
            <Menu>
              {(isOnlyShowSignOut
                ? USER_MENU_ITEMS.slice(-1)
                : USER_MENU_ITEMS
              ).map((link, i) => (
                <MenuItem key={i}>
                  <UserMenuLink
                    label={link.label}
                    href={link.href}
                    onClose={handlePopoverClose}
                  />
                </MenuItem>
              ))}
            </Menu>
          </PopoverContentWrapper>
        }
        trigger='click'
        open={isOpen}
        onOpenChange={handlePopoverChange}
      >
        <LogoutButtonWrapper>
          <UserOutlined />
          <ResponsiveWrapper>{fullName}</ResponsiveWrapper>
        </LogoutButtonWrapper>
      </Popover>

      <TotalMileAmount totalMileAmount={totalMileAmount} />
    </LogoutButtonWrapper>
  );
};

export default MobileLogoutButton;

export const USER_MENU_ITEMS = [
  {
    label: 'Kullanıcı Bilgilerim',
    href: STATIC_ROUTES.userInformation,
  },
  {
    label: 'Kayıtlı Yolcularım',
    href: STATIC_ROUTES.registeredPassengers,
  },
  {
    label: 'Fatura Bilgilerim',
    href: STATIC_ROUTES.billingInformation,
  },
  {
    label: 'Kart Bilgilerim',
    href: STATIC_ROUTES.cardInformation,
  },
  {
    label: 'Seyahatlerim',
    href: STATIC_ROUTES.travels,
  },
  {
    label: 'Çıkış Yap',
    href: '/logout',
  },
];
